import axios from 'axios'
import publish from './pubilshSet'
import connom from './common'
// import avatar from '@/assets/loading.gif'
axios.defaults.timeout = 20000 // 超时响应
axios.defaults.baseURL = publish.baseUrl // 根目录地址
axios.interceptors.request.use(
  config => {
    config.headers = {
      'token': window.localStorage.getItem('baigangToken')
    }
    if (config.url.indexOf('?') >= 0) {
      config.url = config.url + '&t=' + new Date().getTime()
    } else {
      config.url = config.url + '?t=' + new Date().getTime()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
export default {
  get (url, noloading) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.get(url)
        .then(response => {
          if (!noloading) {
            disCover()
          }
          if (response.data.code === 401) {
            window.localStorage.removeItem('baigangToken')
            window.localStorage.removeItem('memberId')
            window.location.href = publish.userCenterHostUrl + 'login'
            setTimeout(() => {
              window.location.reload()
            }, 100)
          }
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.msg,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          if (!noloading) {
            disCover()
          }
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  post (url, data, noloading) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.post(url, data)
        .then(response => {
          if (!noloading) {
            disCover()
          }
          if (response.data.code === 401) {
            window.localStorage.removeItem('baigangToken')
            window.localStorage.removeItem('memberId')
            window.location.href = publish.userCenterHostUrl + 'login'
            setTimeout(() => {
              window.location.reload()
            }, 100)
          }
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            resolve(response.data)
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.msg,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          if (!noloading) {
            disCover()
          }
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  put (url, data) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.put(url, data)
        .then(response => {
          disCover()
          if (response.data.code === 401) {
            window.localStorage.removeItem('baigangToken')
            window.localStorage.removeItem('memberId')
            window.location.href = publish.userCenterHostUrl + 'login'
            setTimeout(() => {
              window.location.reload()
            }, 100)
          }
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.msg,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  del (url) {
    return new Promise((resolve, reject) => {
      coverGif()
      axios.delete(url)
        .then(response => {
          disCover()
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.msg,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disCover()
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  asyncGet (url) {
    var p = new Promise((resolve, reject) => {
      axios.get(url).then(msg => {
        if (msg.data.code === 0) {
          resolve(msg.data.data)
        } else {
          reject(msg)
          if (msg.data.code === 401 || msg.data.code === 402) {
            window.localStorage.removeItem('MemberInfo')
            window.localStorage.removeItem('memberId')
            window.location.href = '//' + window.location.host + '/'
            setTimeout(p => {
              window.location.reload()
            }, 10)
          }
        }
      }).catch(err => {
        if (err.response.status === 401 || err.response.status === 402) {
          window.location.href = '//' + window.location.host + '/'
          setTimeout(() => {
            window.location.reload()
          }, 100)
        }
      })
    })
    console.log(p)
    return p
  }
}
function coverGif () {
  // if (!document.getElementById('loadingGif')) {
  //   let dom = document.createElement('div')
  //   dom.id = 'loadingGif'
  //   let html = '<img src="' + avatar + '" height="200" width="200" style="opacity: 0.5"/>'
  //   dom.innerHTML = html
  //   document.getElementById('app').appendChild(dom)
  // }
}
function disCover () {
  // if (document.getElementById('loadingGif')) {
  //   document.getElementById('app').removeChild(document.getElementById('loadingGif'))
  // }
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js